import React, { useState, useRef } from 'react';
import { HiX } from 'react-icons/hi';
import { HiPlus } from 'react-icons/hi2';

const TagsInput = ({
    post,
    isEditable = true,
    onChange = (tags) => void 0,
    className = '',
    placeholder = 'Add tags...'
}) => {
    const [tags, setTags] = useState(post?.preferences?.tags || []);
    const [inputValue, setInputValue] = useState('');
    const inputRef = useRef(null);
    
    const handleKeyDown = (e) => {
        if (!inputValue.trim()) return;
        
        // Agregar tag con Enter o coma
        if (e.key === 'Enter' || e.key === ',') {
            e.preventDefault();
            addTag(inputValue);
        }
    };

    const addTag = (value) => {
        const newTag = value.trim().replace(/,/g, '');
        if (newTag && !tags.includes(newTag)) {
            const updatedTags = [...tags, newTag];
            setTags(updatedTags);
            onChange(updatedTags);
        }
        setInputValue('');
    };

    const removeTag = (tagToRemove) => {
        const updatedTags = tags.filter(tag => tag !== tagToRemove);
        setTags(updatedTags);
        onChange(updatedTags);
    };

    const handleContainerClick = () => {
        inputRef.current?.focus();
    };

    const totalChars = tags.reduce((acc, tag) => acc + tag.length + 1, 0);
    const remainingChars = 500 - totalChars;

    return (
        <div className="w-full">
            <div 
                onClick={handleContainerClick}
                className={`flex flex-wrap gap-2 p-2 ${
                    isEditable 
                        ? 'hover:bg-gray-50 dark:hover:bg-gray-800/50'
                        : 'bg-gray-50 dark:bg-gray-800'
                } transition-colors min-h-[42px] ${className}`}
            >
                {tags.map((tag, index) => (
                    <span 
                        key={index} 
                        className="flex items-center gap-1 bg-primary-50 dark:bg-primary-900/50 text-primary-700 dark:text-primary-300 px-2 py-1 rounded-md text-sm"
                    >
                        {tag}
                        {isEditable && (
                            <button
                                onClick={() => removeTag(tag)}
                                className="hover:text-primary-800 dark:hover:text-primary-200"
                            >
                                <HiX className="w-3 h-3" />
                            </button>
                        )}
                    </span>
                ))}
                {isEditable && (
                    <div className="flex items-center gap-1 text-tertiary-400">
                        {/* <HiPlus className="w-4 h-4" /> */}
                        <input
                            ref={inputRef}
                            type="text"
                            value={inputValue}
                            onChange={(e) => setInputValue(e.target.value)}
                            onKeyDown={handleKeyDown}
                            onBlur={() => inputValue && addTag(inputValue)}
                            placeholder={tags.length === 0 ? (placeholder || "Add tags...") : ""}
                            className="bg-transparent border-none outline-none p-0 text-tertiary-700 dark:text-gray-200 placeholder-gray-400 dark:placeholder-gray-600 text-sm min-w-[100px] flex-1"
                            disabled={!isEditable}
                        />
                    </div>
                )}
            </div>
            
        </div>
    );
};

export default TagsInput; 